import type { CountryProperty } from 'country-codes-list';
import { customList } from 'country-codes-list';

export type CountryCodeFieldData = {
  name: string;
  dialCode: string;
  countryCode: string;
};

export const defaultCountryCodeValues: CountryCodeFieldData[] = [
  {
    name: 'Deutschland',
    dialCode: '49',
    countryCode: 'DE',
  },
  {
    name: 'Schweiz',
    dialCode: '41',
    countryCode: 'CH',
  },
  {
    name: 'Österreich',
    dialCode: '43',
    countryCode: 'AT',
  },
];

const dialCodeMap: Record<string, string> = customList(
  // oxlint-disable-next-line typescript/consistent-type-assertions
  'countryCode' as CountryProperty,
  '{countryCallingCode}'
);

export const getDialCodeFromCountryCode = (countryCode: string): string =>
  dialCodeMap[countryCode];
